/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCButton from "../../../buttons";


/* Styles */
import styles from "./styles.js"



const Content = props => {
  const { setShowModal, handleDeleteTeam, selectedUser} = props;
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.modalContent}>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="auDeleteWarningModalModal.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove} >
              <UCButton
                className={classes.deleteBtn}
                onClick={() => handleDeleteTeam(selectedUser, selectedUser.id)}
                type="danger"
                text={<FormattedMessage id="auDeleteWarningModalModal.remove"/>}
                spinner={{
                  name: "deleteInviteAuthorisedSpinner",
                  size: 20,
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
